import * as AbReactResources from "abreact/generated/locale/AbReactResources";
import { RouteUtils } from "absdk/preliminary/commons/app/router/RouteUtils";
export const UNKNOWN_ROUTE_TEMPLATE = "/absdk/error/unknownRoute/:route";
export const unknownRouteSpec = {
  routeTemplate: UNKNOWN_ROUTE_TEMPLATE,
  routeTitle: props => AbReactResources.unknownRoute_routeTitle(props.route),
  view: {
    modulePath: () => import(/* webpackChunkName: "Builtin_Routes" */"abreact/incubator/ui/app/routes/UnknownRouteView"),
    exportName: "UnknownRouteView"
  },
  routeParamHandler: {
    paramsFromProps: props => ({
      routeParams: {
        route: props.route
      }
    }),
    propsFromParams: params => ({
      route: RouteUtils.getReqParamAsString(params, "route")
    })
  }
};
//# sourceMappingURL=UnknownRouteSpec.js.map
